// extracted by mini-css-extract-plugin
export var aboutContainer = "index-module--aboutContainer--1A2TP";
export var aboutMePage = "index-module--aboutMePage--HZcOL";
export var callUsContainer = "index-module--callUsContainer---wyVC";
export var contentContainer = "index-module--contentContainer--v3oUL";
export var imgContainer = "index-module--imgContainer--U4Md0";
export var inforContainer = "index-module--inforContainer--ebc-A";
export var inforItem = "index-module--inforItem--EJokG";
export var introGroup = "index-module--introGroup--rlCiY";
export var introItem = "index-module--introItem--1Osez";
export var map = "index-module--map--6sLIw";
export var primaryButton = "index-module--primaryButton--QTWEV";
export var smallContainer = "index-module--smallContainer--RH5mR";
export var title = "index-module--title--uLgr-";
export var typePhoneNumber = "index-module--typePhoneNumber--ViP-A";